import React from 'react'
import { SelectableCardGrid } from '@commutifi-fe/ui'
import { FormItemInjectedProps } from 'shared/interfaces'

export interface SelectableChoicesProps extends FormItemInjectedProps<string[]> {
  // Options label strings
  options: QuestionOptions[]
  // Boolean to indicate if the user can select multiple options or not
  multiSelect?: boolean
}

export interface QuestionOptions {
  label: string
  value: string
}

function SelectableChoices({ id, onChange, options, multiSelect, value }: SelectableChoicesProps) {
  const freezedOptions = React.useMemo(() => options, [options])
  const handleChange = (modes: string[]) => {
    if (onChange) {
      onChange(modes)
    }
  }

  return (
    <SelectableCardGrid
      id={id}
      onChange={handleChange}
      multiSelect={multiSelect}
      initialSelectedCards={value}
      equalWidth
    >
      {freezedOptions.map((option) => (
        <SelectableCardGrid.ClickableCard key={option.value} id={option.value} title={option.label} />
      ))}
    </SelectableCardGrid>
  )
}

export default SelectableChoices
